/**
 * Pergunta de confirmação do cadastro de instalação elétrica (sair sem salvar).
 */
import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
}) => (
  <Dialog open={open} onClose={onCancel} aria-labelledby="electrical-confirm-title">
    <DialogTitle id="electrical-confirm-title">{title}</DialogTitle>
    <DialogContent>
      <DialogContentText sx={{ fontSize: '1rem' }}>{message}</DialogContentText>
    </DialogContent>
    <DialogActions sx={{ p: 2, gap: 1 }}>
      <Button variant="contained" onClick={onCancel} sx={{ minHeight: 44 }} autoFocus>
        {cancelLabel}
      </Button>
      <Button variant="outlined" color="error" onClick={onConfirm} sx={{ minHeight: 44 }}>
        {confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDialog;
